var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorTriangleWhiteOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.75008C12.2676 1.75008 12.515 1.89269 12.6491 2.1243L23.6491 21.1243C23.7834 21.3563 23.7837 21.6424 23.6497 21.8747C23.5158 22.107 23.2681 22.2501 23 22.2501H1C0.731891 22.2501 0.484172 22.107 0.350257 21.8747C0.216341 21.6424 0.216598 21.3563 0.35093 21.1243L11.3509 2.1243C11.485 1.89269 11.7324 1.75008 12 1.75008ZM2.30083 20.7501H21.6992L12 3.99697L2.30083 20.7501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.7501C12.4142 16.7501 12.75 17.0859 12.75 17.5001V18.0001C12.75 18.4143 12.4142 18.7501 12 18.7501C11.5858 18.7501 11.25 18.4143 11.25 18.0001V17.5001C11.25 17.0859 11.5858 16.7501 12 16.7501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 8.75034C12.4136 8.74999 12.7497 9.0855 12.75 9.49971L12.7542 14.4995C12.7545 14.9137 12.419 15.2497 12.0048 15.2501C11.5906 15.2504 11.2545 14.9149 11.2542 14.5007L11.25 9.50096C11.2497 9.08675 11.5852 8.75068 11.9994 8.75034Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleWhiteOutline);
export default __webpack_public_path__ + "static/media/error-triangle-white-outline.63806624.svg";
export { ForwardRef as ReactComponent };